import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd292fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-2 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = {
  key: 0,
  class: "py-4 sm:py-10 lg:py-4 xl:py-10"
}
const _hoisted_4 = {
  key: 1,
  class: "py-4 sm:py-10 lg:py-4 xl:py-10"
}
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex py-6" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "row-span-2 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_11 = { class: "max-w-sm border-b-2 mb-6" }
const _hoisted_12 = { class: "font-bold text-xl" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "max-w-sm border-b-2 mb-6" }
const _hoisted_15 = { class: "font-bold text-xl" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "max-w-sm border-b-2 mb-6" }
const _hoisted_18 = { class: "font-bold text-xl" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "max-w-sm border-b-2 mb-6" }
const _hoisted_21 = { class: "font-bold text-xl" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "max-w-sm border-b-2 mb-6" }
const _hoisted_24 = { class: "font-bold text-xl" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import TipsQualityBox from '@/components/video-diagnostic/TipsQualityBox.vue'
import { getQualityScore } from '@/composables/video-diagnostic/useGetQualityScore'
import { useVideoDiagnostic } from '@/composables/video-diagnostic/useVideoDiagnostic'
import CommonState from '@/services/locale-state'
import { Stage, Topic, QualityScore } from '@/types/enums/video-diagnostic.enum'
import { IUpdateTopic } from '@/types/interfaces/video-diagnostic.interface'
import { watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { videoInputTestPassed } from '@/composables/video-diagnostic/useCameraTest'
import { audioTestPassed } from '@/composables/video-diagnostic/useAudioTest'
import Video from 'twilio-video'

interface ResultEmits {
  (e: 'nextStage', value: number): void
  (e: 'updateTopic', value: IUpdateTopic): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Result',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "updateTopic"],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const route = useRoute()
const { sendReport, isLoading } = useVideoDiagnostic()

const props = __props

const supportTel = computed(() =>
  CommonState.getCountry() === 'vn' ? '0906.830.230' : '02-026-6683',
)

const emit = __emit

watch(
  () => props.stage,
  async (stage, prevStage) => {
    if (prevStage === Stage.RESULTS && stage === Stage.QUALITY) {
      emit('updateTopic', { topic: Topic.RESULTS, active: false })
    }
    if (stage === Stage.RESULTS) {
      emit('updateTopic', { topic: Topic.RESULTS, active: true })
    }
  },
)

const { totalQualityScore } = getQualityScore()

const qualityScorePassed = computed(
  () =>
    totalQualityScore.value === QualityScore.Excellent ||
    totalQualityScore.value === QualityScore.Good,
)
const testsPassed = computed(
  () =>
    (totalQualityScore.value === QualityScore.Excellent ||
      totalQualityScore.value === QualityScore.Good) &&
    videoInputTestPassed.value &&
    audioTestPassed.value &&
    Video.isSupported,
)
const qualityScore = computed(() => QualityScore[totalQualityScore.value].toLowerCase())

const refreshPage = () => {
  router.go(0)
}

const backToFirstPage = () => {
  router.go(-1)
}

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).RESULTS,
    class: _normalizeClass([__props.stage === _unref(Stage).RESULTS ? 'block' : 'hidden md:block opacity-0 pointer-events-none', "result-container"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(testsPassed.value
              ? _ctx.$t('video-diagnostic.all-test-passed')
              : _ctx.$t('video-diagnostic.some-test-failed')), 1),
        (testsPassed.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('video-diagnostic.test-past-detail')), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('video-diagnostic.some-test-failed')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.test-failed-detail')) + " ", 1),
              (_unref(route).query.exitPath)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('video-diagnostic.test-failed-detail2', { tel: supportTel.value })), 1))
                : _createCommentVNode("", true)
            ])),
        (!testsPassed.value)
          ? (_openBlock(), _createBlock(TipsQualityBox, { key: 2 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_unref(route).query.exitPath)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-submit",
                type: "button",
                disabled: _unref(isLoading),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(sendReport) && _unref(sendReport)(...args)))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Loading, {
                    class: "mr-2",
                    "is-loading": _unref(isLoading)
                  }, null, 8, ["is-loading"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.finish')), 1)
                ])
              ], 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "text-white border-2 rounded-md border-white bg-primary-color py-2 px-4 mr-4",
                type: "button",
                onClick: backToFirstPage
              }, _toDisplayString(_ctx.$t('video-diagnostic.back')), 1)),
          _createElementVNode("button", {
            class: "bg-white border py-2 px-4 rounded-md",
            type: "button",
            onClick: refreshPage
          }, _toDisplayString(_ctx.$t('video-diagnostic.restart-test')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h2", _hoisted_12, [
            _createVNode(_component_SvgIcon, {
              class: _normalizeClass([_unref(videoInputTestPassed) ? 'text-green-500' : '', "icon-container mr-2"]),
              icon: _unref(videoInputTestPassed) ? 'correct-circle' : 'error-sign',
              "inherit-fill": true,
              height: "16"
            }, null, 8, ["class", "icon"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.section-camera.header')), 1)
          ]),
          _createElementVNode("p", {
            class: "py-4",
            innerHTML: 
              _unref(videoInputTestPassed)
                ? _ctx.$t('video-diagnostic.section-camera.passed-message')
                : _ctx.$t('video-diagnostic.section-camera.failed-message')
            
          }, null, 8, _hoisted_13)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h2", _hoisted_15, [
            _createVNode(_component_SvgIcon, {
              class: _normalizeClass([_unref(audioTestPassed) ? 'text-green-500' : '', "icon-container mr-2"]),
              icon: _unref(audioTestPassed) ? 'correct-circle' : 'error-sign',
              "inherit-fill": true,
              height: "16"
            }, null, 8, ["class", "icon"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.section-speaker-and-mic.header')), 1)
          ]),
          _createElementVNode("p", {
            class: "py-4",
            innerHTML: 
              _unref(audioTestPassed)
                ? _ctx.$t('video-diagnostic.section-speaker-and-mic.passed-message')
                : _ctx.$t('video-diagnostic.section-speaker-and-mic.failed-message')
            
          }, null, 8, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h2", _hoisted_18, [
            _createVNode(_component_SvgIcon, {
              class: _normalizeClass([_unref(Video).isSupported ? 'text-green-500' : '', "icon-container mr-2"]),
              icon: _unref(Video).isSupported ? 'correct-circle' : 'error-sign',
              "inherit-fill": true,
              height: "16"
            }, null, 8, ["class", "icon"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.section-browser.header')), 1)
          ]),
          _createElementVNode("p", {
            class: "py-4",
            innerHTML: 
              _unref(Video).isSupported
                ? _ctx.$t('video-diagnostic.section-browser.passed-message')
                : _ctx.$t('video-diagnostic.section-browser.failed-message')
            
          }, null, 8, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("h2", _hoisted_21, [
            _createVNode(_component_SvgIcon, {
              class: "icon-container text-green-500 mr-2",
              icon: 'correct-circle',
              "inherit-fill": true,
              height: "16"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.connectivity-result')), 1)
          ]),
          _createElementVNode("p", {
            class: "py-4",
            innerHTML: _ctx.$t('video-diagnostic.connectivity-detail')
          }, null, 8, _hoisted_22)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h2", _hoisted_24, [
            _createVNode(_component_SvgIcon, {
              class: _normalizeClass([qualityScorePassed.value ? 'text-green-500' : '', "icon-container mr-2"]),
              icon: qualityScorePassed.value ? 'correct-circle' : 'error-sign',
              "inherit-fill": true,
              height: "16"
            }, null, 8, ["class", "icon"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.quality-performance')), 1)
          ]),
          (qualityScorePassed.value)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "py-4",
                innerHTML: 
              _ctx.$t('video-diagnostic.quality-performance-detail-passed', {
                qualityScore: qualityScore.value,
              })
            
              }, null, 8, _hoisted_25))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "py-4",
                innerHTML: 
              _ctx.$t('video-diagnostic.quality-performance-detail-failed', {
                qualityScore: qualityScore.value,
              })
            
              }, null, 8, _hoisted_26))
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})